<template>
  <v-card flat class="pb-0">
    <v-card-text class="pb-0">
      <p class="display-1 text--primary autoHypen">{{ $t(title) }}</p>
      <p v-html="$t(description)" class="mb-0 pb-4 autoHypen"></p>
      <Debug :debug="debug" />
      <v-img contain class="hidden-sm-and-down" v-if="image" :src="image" :height="imageHeight" justify="center" />
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-bottom-sheet v-model="dialog" inset max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="hasInstructions"
            icon
            fab
            small
            v-bind="attrs"
            v-on="on"
            data-test-instruction-toggle
            aria-label="Help"
          >
            <v-icon> mdi-help-box </v-icon>
          </v-btn>
        </template>

        <InstructionCard
          :instructionTitle="instructionTitle"
          :instructionText="instructionText"
          :instructionPictures="instructionPictures"
          @clicked="disableDialog"
        />
      </v-bottom-sheet>
    </v-card-actions>
    <slot></slot>
  </v-card>
</template>

<script lang="ts">
import Debug from "@/components/utility/Debug.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import InstructionCard from "@/components/instructions/InstructionCard.vue";

@Component({
  components: {
    InstructionCard,
    Debug
  }
})
export default class ReportHeader extends Vue {
  dialog = false;

  @Prop({ default: 6 })
  md!: number;

  @Prop({})
  debug!: any;

  @Prop({})
  description!: string;

  @Prop({})
  title!: string;

  @Prop({})
  image!: string;

  @Prop({})
  hasInstructions!: boolean;

  @Prop({ default: "Anleitung" })
  instructionTitle!: string;

  @Prop({ default: "Hier ist ein Beispiel wie das Foto am besten aufzunehmen ist." })
  instructionText!: string;

  @Prop()
  instructionPictures!: string[];

  @Prop({ default: 175 })
  imageHeight!: number;

  disableDialog() {
    this.dialog = false;
  }
}
</script>

<style scoped>
.autoHypen {
  hyphens: auto;
}
</style>
